import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import RequireOrg from "./components/RequireOrg";
import { Toaster } from "./components/ui/sonner";

// Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import OnboardingPage from "./pages/OnboardingPage";
import DashboardPage from "./pages/DashboardPage";
import ExecutionAgentsPage from "./pages/ExecutionAgentsPage";
import ExecutionAgentBuilderPage from "./pages/ExecutionAgentBuilderPage";
import ExecutionAgentDetailPage from "./pages/ExecutionAgentDetailPage";
import ExecutionAgentEditPage from "./pages/ExecutionAgentEditPage";
import AgentsPage from "./pages/AgentsPage";
import AgentDashboardPage from "./pages/AgentDashboardPage";
import AgentBuilderPage from "./pages/AgentBuilderPage";
import ProvingGroundsPage from "./pages/ProvingGroundsPage";
import WidgetPreviewPage from "./pages/WidgetPreviewPage";
import ConversationsPage from "./pages/ConversationsPage";
import ContactsPage from "./pages/ContactsPage";
import SettingsPage from "./pages/SettingsPage";
import ApiKeysPage from "./pages/ApiKeysPage";
import KnowledgeBasePage from "./pages/KnowledgeBasePage";
import AdminPage from "./pages/AdminPage";
import IntegrationsPage from "./pages/IntegrationsPage";
import IntegrationDetailPage from "./pages/IntegrationDetailPage";
import CronJobsPage from "./pages/CronJobsPage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            
            {/* Protected - needs auth */}
            <Route path="/onboarding" element={
              <ProtectedRoute>
                <OnboardingPage />
              </ProtectedRoute>
            } />
            
            {/* Protected - needs auth + org */}
            <Route path="/dashboard" element={
              <RequireOrg>
                <DashboardPage />
              </RequireOrg>
            } />
            <Route path="/agents" element={
              <RequireOrg>
                <AgentsPage />
              </RequireOrg>
            } />
            <Route path="/runtime" element={<Navigate to="/agents" replace />} />
            <Route path="/agent-employees" element={
              <RequireOrg>
                <ExecutionAgentsPage />
              </RequireOrg>
            } />
            <Route path="/agent-employees/new" element={
              <RequireOrg>
                <ExecutionAgentBuilderPage />
              </RequireOrg>
            } />
            <Route path="/agent-employees/:projectId" element={
              <RequireOrg>
                <ExecutionAgentDetailPage />
              </RequireOrg>
            } />
            <Route path="/agent-employees/:projectId/edit" element={
              <RequireOrg>
                <ExecutionAgentEditPage />
              </RequireOrg>
            } />
            <Route path="/runtime/tasks/:taskId" element={<Navigate to="/agents" replace />} />
            <Route path="/agents/new" element={
              <RequireOrg>
                <AgentBuilderPage />
              </RequireOrg>
            } />
            <Route path="/agents/:agentId" element={
              <RequireOrg>
                <AgentDashboardPage />
              </RequireOrg>
            } />
            <Route path="/agents/:agentId/edit" element={
              <RequireOrg>
                <AgentBuilderPage />
              </RequireOrg>
            } />
            <Route path="/agents/:agentId/proving-grounds" element={
              <RequireOrg>
                <ProvingGroundsPage />
              </RequireOrg>
            } />
            <Route path="/agents/:agentId/widget" element={
              <RequireOrg>
                <WidgetPreviewPage />
              </RequireOrg>
            } />
            <Route path="/conversations" element={
              <RequireOrg>
                <ConversationsPage />
              </RequireOrg>
            } />
            <Route path="/contacts" element={
              <RequireOrg>
                <ContactsPage />
              </RequireOrg>
            } />
            <Route path="/settings" element={
              <RequireOrg>
                <SettingsPage />
              </RequireOrg>
            } />
            <Route path="/integrations" element={
              <RequireOrg>
                <IntegrationsPage />
              </RequireOrg>
            } />
            <Route path="/integrations/:integrationId" element={
              <RequireOrg>
                <IntegrationDetailPage />
              </RequireOrg>
            } />
            <Route path="/cron-jobs" element={
              <RequireOrg>
                <CronJobsPage />
              </RequireOrg>
            } />
            <Route path="/api-keys" element={
              <RequireOrg>
                <ApiKeysPage />
              </RequireOrg>
            } />
            <Route path="/knowledge-base" element={
              <RequireOrg>
                <KnowledgeBasePage />
              </RequireOrg>
            } />
            <Route path="/admin" element={
              <RequireOrg>
                <AdminPage />
              </RequireOrg>
            } />
            
            {/* Redirect root to dashboard */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            {/* Catch all */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
